import { render, staticRenderFns } from "./LoginUser.vue?vue&type=template&id=fbaaeca8"
import script from "./LoginUser.vue?vue&type=script&lang=js"
export * from "./LoginUser.vue?vue&type=script&lang=js"
import style0 from "./LoginUser.vue?vue&type=style&index=0&id=fbaaeca8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports